'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function birthDate(options) {
    return {
        id: 'date-field',
        component: 'magic-ui-form-field',
        isDataField: false,
        testId: 'step2-date',
        properties: {
            label: magicCommon.translate('sign-up-step-two.dob.label'),
        },
        children: [
            {
                id: 'dob',
                serverId: 'birthDate',
                component: 'magic-ui-date',
                isStandAlone: true,
                isDataField: true,
                validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
                properties: {
                    'has-success': false,
                    'amend-dob-hint': options.amendDobHint,
                    'minimum-age': options.minimumAge,
                    'maximum-age': options.maximumAge,
                    'enable-reasonable-dob': true,
                    'info': options.mdyFormat
                        ? magicCommon.translate('sign-up-step-two.dob.hint.mdy')
                        : magicCommon.translate('sign-up-step-two.dob.hint'),
                    'value': options.initialValue,
                },
                converter: function (formValue) {
                    return {
                        birthDate: formValue.dob.value,
                    };
                },
            },
        ],
    };
}

exports.birthDate = birthDate;
